module.exports = __webpack_public_path__ + "img/button_download_mac.bc73cb01.png";